import { formatHmm } from './hours'

/** Meer dan dit op een dag weigert de server; dag- en weekweergave delen de grens. */
export const MAX_DAY_HOURS = 24

/** Hoe een urenregel heet in meldingen, menu's en dialogen. */
export function rowLabel(clientName: string, projectName: string, categoryName: string | null): string {
  return [clientName, projectName, categoryName].filter(Boolean).join(' · ')
}

/**
 * De uitleg bij een urenveld dat tegenhoudt, of null als er niets aan de hand is.
 *
 * Het veld is op dat moment gevuld, dus er past geen notitie in: de rode rand draagt
 * het signaal en deze zin hangt in een tooltip plus in de sr-only tekst waar
 * aria-describedby naar wijst. Dat de grens overschreden is lees je los daarvan al af
 * aan het dagtotaal, dat rood kleurt.
 */
export function hoursMessage(invalid: boolean, prospectiveDayTotal: number): string | null {
  if (invalid) return 'Ongeldige invoer, gebruik bijvoorbeeld 1:30 of 1,5.'
  if (prospectiveDayTotal > MAX_DAY_HOURS) {
    return `Het dagtotaal komt op ${formatHmm(prospectiveDayTotal)} en dat is meer dan ${MAX_DAY_HOURS} uur. Deze regel wordt niet opgeslagen.`
  }
  return null
}

/**
 * De vocabulaire van een urenregel die nog niet wegschrijft. De dagtabel en de
 * celpopover voeren dezelfde woorden, zoals invoice-status-copy.ts dat doet voor
 * factuurstatussen.
 *
 * Twee toestanden, en ze beantwoorden verschillende vragen. `required` toont de eis
 * voordat je hem overtreedt; `blocked` verschijnt pas als een opslagpoging er echt op
 * strandt en noemt daarom het gevolg, niet de regel.
 */
export const descriptionCopy = {
  /** Kleine letter: een eigenschap van het veld, geen mededeling. */
  required: 'verplicht',
  blocked: 'Niet opgeslagen',
  /** Een label binnen het veld wordt niet betrouwbaar voorgelezen; deze zin wel. */
  requiredHint: 'Omschrijving is verplicht zodra er uren staan.',
  blockedMessage: 'Deze uren zijn niet opgeslagen. Vul een omschrijving in.',
  /** De leesvariant: bij het terugkijken is een lege omschrijving juist het signaal. */
  missing: 'Omschrijving ontbreekt',
} as const

/**
 * Wat er in de omschrijvingskolom hoort te staan als je uren teruguleest. Een lege
 * omschrijving is alleen een gemis zodra er uren tegenover staan; bij nul uur is er
 * simpelweg niets te melden.
 */
export function readDescription(description: string, hours: number): { text: string; missing: boolean } {
  if (description.trim() !== '') return { text: description, missing: false }
  const missing = hours > 0

  return { text: missing ? descriptionCopy.missing : '', missing }
}
